import * as SG from 'styles';

import { Loader } from 'components/Loader';
import { Modal } from 'components/Modal';

import { useQuickOrderModal } from './QuickOrderModal.hooks';
import * as S from './QuickOrderModal.styles';

type QuickOrderModalProps = {
  onClose: () => void;
};

export function QuickOrderModal(props: QuickOrderModalProps): React.ReactElement {
  const { onClose } = props;

  const { isLoading, productsComponents } = useQuickOrderModal();

  return (
    <Modal onClose={onClose} hasModalChild={true}>
      <S.Content>
        <Loader isLoading={isLoading}>
          <SG.Inner>
            <S.Wrapper>{productsComponents}</S.Wrapper>
          </SG.Inner>
        </Loader>
      </S.Content>
    </Modal>
  );
}
